
import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Modal,
  Typography,
  IconButton,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../services/api";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 900,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
  overflowY: "auto",
};

const InstituteSummaryModal = ({ open, onClose, instituteId }) => {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);

  // ------------ Fetch Summary --------------
  const fetchSummary = useCallback(async () => {
    if (!instituteId) {
      console.log("NO instituteId received");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      console.log("Fetching summary for ID:", instituteId);

      const res = await api.post(
        "/event/institutes-summary",
        { institute_ids: [instituteId] },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let data = res.data;

      if (Array.isArray(data) && data.length > 0) {
        setSummary(data[0]);
      } else if (data && typeof data === "object") {
        setSummary(data);
      } else {
        setSummary(null);
      }
    } catch (err) {
      console.log("Summary fetch error:", err);
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, [instituteId]);


  useEffect(() => {
    if (open) fetchSummary();
  }, [open, fetchSummary]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h5" fontWeight="bold" color="#5784bfff">
            Institute Summary
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        {loading ? (
          <Box sx={{ textAlign: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : !summary || summary.detail ? (
          <Typography textAlign="center" sx={{ mt: 2 }}>
            No data available.
          </Typography>
        ): (
          <Paper sx={{ p: 2 }}>
            <TableContainer>
              <Table>
                <TableHead sx={{ background: "#E8F2FF" }}>
                  <TableRow>
                    <TableCell>Institute Name</TableCell>
                    <TableCell>Student limit approved</TableCell>
                    <TableCell>Student limit used</TableCell>
                    <TableCell>Tech camp done</TableCell>
                    <TableCell>Students Trained</TableCell>
                    <TableCell>Fdp done</TableCell>
                    <TableCell>FDP Faculty trained</TableCell>
                    <TableCell>Edp done</TableCell>
                    <TableCell>EDP Faculty trained</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  <TableRow>
                    <TableCell>{summary.institute_name}</TableCell>
                    <TableCell>{summary.registration_limit}</TableCell>
                    <TableCell>{summary.student_intake_count}</TableCell>
                    <TableCell>{summary.techcamp_count}</TableCell>
                    <TableCell>{summary.students_trained}</TableCell>
                    <TableCell>{summary.fdp_hosted}</TableCell>
                    <TableCell>{summary.fdp_educators_trained}</TableCell>
                    <TableCell>{summary.edp_count}</TableCell>
                    <TableCell>{summary.edp_educators_trained}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    </Modal>
  );
};

export default InstituteSummaryModal;
